"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatInputPopup = exports.SeatInput = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Field_1 = require("../../../Form/Field");
const Sub_1 = require("../../../Page/Title/Sub");
const Confirm_1 = require("../../../Popup/Confirm");
const ValidationErrors_1 = require("../../../ValidationErrors");
const SeatInput = (props) => {
    var _a;
    const { data = {}, errors, onChange, onSubmit } = props;
    const [seat, setSeat] = (0, react_1.useState)(data);
    const selectionRageUpdateRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        onChange === null || onChange === void 0 ? void 0 : onChange(seat);
    }, [seat, onChange]);
    (0, react_1.useEffect)(() => {
        selectionRageUpdateRef.current;
    }, [seat]);
    const handleSubmit = (0, react_1.useCallback)((event) => {
        event.preventDefault();
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(seat);
    }, [seat, onSubmit]);
    const handleChange = (0, react_1.useCallback)((event) => {
        const { name, value } = event.target;
        if (!/^[0-9A-Za-z]*$/.test(value)) {
            return;
        }
        selectionRageUpdateRef.current = () => {
            event.target.setSelectionRange(event.target.selectionStart || value.length, event.target.selectionEnd || value.length);
        };
        setSeat((prev) => ({ ...prev, [name]: value.toUpperCase() }));
    }, []);
    const getError = (0, react_1.useCallback)((fieldName) => {
        return (0, ValidationErrors_1.getFormError)(errors, fieldName);
    }, [errors]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("form", { onSubmit: handleSubmit },
            react_1.default.createElement(Field_1.FormField, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:SeatLabel', defaultMessage: 'Seat label' }), placeholder: '13A', name: 'seatLabel', error: getError('seatLabel'), onChange: handleChange, value: (_a = seat.seatLabel) !== null && _a !== void 0 ? _a : '' }))));
};
exports.SeatInput = SeatInput;
const SeatInputPopup = (props) => {
    const { errors, selectSeat, close } = props;
    const [seatLabel, setSeatLabel] = (0, react_1.useState)(props.seatLabel);
    (0, react_1.useEffect)(() => {
        setSeatLabel(props.seatLabel);
    }, [props.seatLabel]);
    return (react_1.default.createElement(Confirm_1.PopupConfirm, { isOpened: true, confirmMessage: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Sub_1.PageSubTitle, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Seat/AircraftSeatsSelection/Popup/SeatInputPopup:Title', defaultMessage: 'Seat selection' }) })), onConfirm: () => selectSeat(seatLabel), onClose: close, modificators: ['xs'] },
        react_1.default.createElement(exports.SeatInput, { data: {
                seatLabel,
            }, errors: errors, onChange: (data) => setSeatLabel(data.seatLabel) })));
};
exports.SeatInputPopup = SeatInputPopup;
//# sourceMappingURL=index.js.map